export const getRealContent = (node: any) => {
  for (const key in node) {
    if (typeof node[key] === 'string' && node[key].includes('DO_NOT_DELETE_DUMMY_ENTITY')) {
      return null;
    }
  }

  return node;
};

export const getRealNodes = (data: any) => {
  return data.nodes.filter((node: any) => {
    return getRealContent(node) !== null;
  });
};
